export const ADS_ACTION_ENTITY_TYPES = [
  { id: 'campaign', name: 'campaign' },
  { id: 'ad_group', name: 'ad_group' },
  { id: 'keyword', name: 'keyword' },
  { id: 'ad', name: 'ad' },
  { id: 'shared_set', name: 'shared_set' },
];

export const ADS_ACTION_NAMES = [
  'pause',
  'enable',
  'set_budget',
  'set_keyword_bid',
  'set_target_cpa',
  'set_target_roas',
  'add_negative',
  'remove_negative',
  'add_to_shared_set',
  'remove_from_shared_set',
  'attach_shared_set',
  'detach_shared_set',
  'set_bidding_strategy',
  'add_negatives',
  'add_keywords',
  'create_ad',
  'remove_keyword',
  'create_ad_group',
  'create_campaign',
].map((name) => ({ id: name, name }));

export const ADS_ACTION_STATUSES = [
  'proposed',
  'approved',
  'rejected',
  'picked',
  'done',
  'failed',
  'stale',
  'previewed',
  'expired',
].map((name) => ({ id: name, name }));

const NEGATIVE_HINT = '{"text":"free","match_type":"BROAD"}';

export const ADS_ACTION_PARAM_HINTS = {
  pause: '{}',
  enable: '{}',
  set_budget: '{"amount": 45}',
  set_keyword_bid: '{"cpc": 1.2}',
  set_target_cpa: '{"value": 40}',
  set_target_roas: '{"value": 2.5}',
  add_negative: NEGATIVE_HINT,
  remove_negative: NEGATIVE_HINT,
  add_to_shared_set: NEGATIVE_HINT,
  remove_from_shared_set: NEGATIVE_HINT,
  attach_shared_set: '{"shared_set_id": 777}',
  detach_shared_set: '{"shared_set_id": 777}',
  set_bidding_strategy: '{"strategy":"TARGET_CPA","target_cpa":40}',
  add_negatives: '{"match_type":"PHRASE","terms":["free","cheap"]}',
  add_keywords: '{"keywords":[{"text":"haze gummies","match_type":"EXACT"}]}',
  create_ad: '{"headlines":["Headline 1","Headline 2","Headline 3"],"descriptions":["Description 1","Description 2"],"final_url":"https://…"}',
  remove_keyword: '{}',
  create_ad_group: '{"name":"…","keywords":[{"text":"…","match_type":"EXACT"}],"ad":{"headlines":["Headline 1","Headline 2","Headline 3"],"descriptions":["Description 1","Description 2"],"final_url":"https://…"}}',
  create_campaign: '{"name":"…","daily_budget":50,"ad_group":{"name":"…","keywords":[…],"ad":{…}}}',
};

export const ADS_ACTION_STATUS_COLORS = {
  proposed: 'warning',
  approved: 'info',
  picked: 'default',
  done: 'success',
  previewed: 'secondary',
  failed: 'error',
  stale: 'warning',
  rejected: 'default',
  expired: 'default',
};
